import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss.js';
import { COLOR_CLASS } from '../../../../tokens/token-build/js/constants/_color-classes.js';

const Icon = React.memo(React.forwardRef(
// eslint-disable-next-line no-restricted-syntax
({ icon, color, customColor, size = 24, className, ...restProps }, ref) => {
    const style = {};
    if (customColor) {
        style.color = customColor;
    }
    return (jsx("svg", { ref: ref, width: `${size}px`, height: `${size}px`, className: classNames(styles.inlineIcon, className, !customColor && color && COLOR_CLASS[color]), style: style, ...restProps, children: jsx("use", { xlinkHref: `#${icon}` }) }));
}));

export { Icon };
